
exports.registrarEventoAnalitica = function(ReactGA, categoria, accion, elemento, valor){
    var tipoUsuarioGoogleAnalytics = ""

    if(localStorage.getItem("installationName") !== null){
        if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
          tipoUsuarioGoogleAnalytics = "[INSTALADOR]"
        }
        else{
          tipoUsuarioGoogleAnalytics = "[USUARIO]"
        }
    }    
    else{
        tipoUsuarioGoogleAnalytics = "[ANÓNIMO]"
    }

    // Más info aqui: https://www.npmjs.com/package/react-ga4

    ReactGA.event({
        category: tipoUsuarioGoogleAnalytics + ' '+ categoria,
        action: tipoUsuarioGoogleAnalytics + ' '+ accion,
        label: elemento, // optional
        value: parseInt(valor) // optional, must be a number
        //nonInteraction: true, // optional, true/false
        //transport: "xhr", // optional, beacon/xhr/image
    })
}

exports.mostrarPrivacidad = function(){
  document.getElementById("asideCookies").className = "cookies"
  document.getElementById("asideCookies").style = "display"
  document.getElementById("linkConsentimiento").click()
}

exports.visibilidadCookies = function(ReactGA,Cookies){

  if(localStorage.getItem("FEVERGY_cookies") === null){
    document.getElementById("asideCookies").className = "cookies"
    document.getElementById("asideCookies").style = "display"
  }  
  else{
    if(localStorage.getItem("FEVERGY_cookies") === "true"){      
      module.exports.cookiesAceptarTodas(ReactGA)
    }
    else{      
      module.exports.cookiesSoloFuncionales(Cookies)
    }
  }  

}

exports.cookiesAceptarTodas = function(ReactGA){

  if (typeof window !== 'undefined') {  
    try{
      ReactGA.initialize("G-YXBTC316NM") 
      console.log("Google Analytics inicializado correctamente.")
    }
    catch(error){
      console.log("Google Analytics no se pudo inicializar.")
    }
  }

  if( (window.location.href !== "https://helias.fevergy.com/") && (!window.location.href.includes("InitialConfig")) && (!window.location.href.includes("Analisis-12-Facturas")) && (!window.location.href.includes("Installer"))){
    module.exports.cargarCabeceraAdSense()
  }
  
  if(document.getElementById("asideCookies") !== null){
    document.getElementById("asideCookies").style = "display: none"
  }    

  localStorage.setItem("FEVERGY_cookies", "true")

}

exports.disableDefaultTracker = (Cookies) => { 
  try{
    // Remove the default tracker.
    if (window.ga) window.ga('remove');
    // Remove the default cookies
    // _ga is used to distinguish users.
    Cookies.remove('_ga', { path: '/', domain: document.domain });
    Cookies.remove('_ga_YXBTC316NM', { path: '/', domain: document.domain });    
    // _gid is used to distinguish users.
    Cookies.remove('_gid', { path: '/', domain: document.domain });
    Cookies.remove('_gid_YXBTC316NM', { path: '/', domain: document.domain });
    // _gat is used to throttle request rate.
    Cookies.remove('_gat', { path: '/', domain: document.domain });
    Cookies.remove('_gat_YXBTC316NM', { path: '/', domain: document.domain });
  }
  catch(error){
    console.log("Google Analytics ya estaba desactivado.")
  }
}

exports.cookiesSoloFuncionales = function(Cookies){

  module.exports.disableDefaultTracker(Cookies)

  if(document.getElementById("asideCookies") !== null){        
    document.getElementById("asideCookies").style = "display: none"
  }    

  localStorage.setItem("FEVERGY_cookies", "false")

}

exports.autocierrePrivacidadGoogle = function(){  
  var intentosCierre = 0
  var ocultarMensajePrivacidad = setInterval(function(){				
    try{
      document.getElementsByClassName("google-revocation-link-placeholder")[0].remove()			           
      clearInterval(ocultarMensajePrivacidad)
    }
    catch(error){
      /* Todavía no está o ya no está */
      intentosCierre = intentosCierre + 1        
      if(intentosCierre === 1000){
        clearInterval(ocultarMensajePrivacidad)
      }
    }
  },10);

}

exports.cargarCabeceraAdSense = function (){

    var datosStripe = {}
                      
    if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
      datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
    } 

    if( (datosStripe.status === undefined) || (datosStripe.status === "trialing") || (datosStripe.status === "paused")){
      console.log("Cargo módulo de Ad-Sense para publicidad")
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.setAttribute("crossorigin", "anonymous");
      script.setAttribute("data-overlays", "bottom");
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7980159048715493";
      head.appendChild(script);
    }
    else{
      console.log("Modelo con suscripción, no cargo publicidad.")
    }

}

exports.obtenerEmailUsuario = function(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        

    userData = JSON.parse(userData);

    var email = ""

    if(userData !== null){
        for (var i = 0; i < userData.UserAttributes.length; i++) {                
            if(userData.UserAttributes[i].Name === "email"){
                email = userData.UserAttributes[i].Value            
            }        
        }
    }    

    return email

}

exports.obtenerNombreUsuario = function(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        

    userData = JSON.parse(userData);

    var nombre = ""    
        
    for (var i = 0; i < userData.UserAttributes.length; i++) {
        if(userData.UserAttributes[i].Name === "name"){
        nombre = userData.UserAttributes[i].Value            
        }
    }

    return nombre

}

exports.obtenerApellidosUsuario = function(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        

    userData = JSON.parse(userData);
    
    var apellidos = ""
        
    for (var i = 0; i < userData.UserAttributes.length; i++) {
        if(userData.UserAttributes[i].Name === "family_name"){
        apellidos = userData.UserAttributes[i].Value            
        }
    }

    return apellidos

}

exports.obtenerNombreCompletoUsuario = function(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        

    userData = JSON.parse(userData);

    var nombre = ""
    var apellidos = ""
        
    for (var i = 0; i < userData.UserAttributes.length; i++) {
        if(userData.UserAttributes[i].Name === "name"){
        nombre = userData.UserAttributes[i].Value            
        }
    }

    for (i = 0; i < userData.UserAttributes.length; i++) {
        if(userData.UserAttributes[i].Name === "family_name"){
        apellidos = userData.UserAttributes[i].Value            
        }
    }

    return nombre+" "+apellidos

}

exports.obtenerTelefonoUsuario = function(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        

    userData = JSON.parse(userData);

    var telefono = ""
        
    for (var i = 0; i < userData.UserAttributes.length; i++) {
        if(userData.UserAttributes[i].Name === "phone_number"){
        telefono = userData.UserAttributes[i].Value            
        }
    }

    return telefono

}

exports.gestionarVisibilidadBubbleIntro = function(idBubbleIntro){

    if ( document.getElementById(idBubbleIntro).className.includes("hidden") ) {
        document.getElementById(idBubbleIntro).className = document.getElementById(idBubbleIntro).className.replace(" hidden","")
    }
    else{
        document.getElementById(idBubbleIntro).className += " hidden"
    }
  
}

exports.obtenerTipoPlataforma = function(){
    
    var tipoDispositivoMovil = ""

    const ua = navigator.userAgent

    if(ua.includes("(iPad;") || ( (/android/i.test(ua)) && (!/Mobile/i.test(ua)) ) ){
      tipoDispositivoMovil = "Web"
    }
    else{

      if ( /android/i.test(ua) && !/Version/i.test(ua) && /Mobile/i.test(ua)) {
          tipoDispositivoMovil = "Android Mobile - Web"
      }
      else if ( /iPad|iPhone|iPod/i.test(ua) && /Version|CriOS/i.test(ua) && /Mobile/i.test(ua) ){
          tipoDispositivoMovil = "iOS Mobile - Web"
      }
      else if ( /android/i.test(ua) && !/Version/i.test(ua) ) {
          tipoDispositivoMovil = "Android - Web"
      }
      else if ( /Macintosh/i.test(ua) && /Version|CriOS/i.test(ua) ){
          tipoDispositivoMovil = "iOS - Web"
      }    
      else if (/android/i.test(ua) && /Version/i.test(ua) ) {
        tipoDispositivoMovil = "Android"
      }
      else if (/iPad|iPhone|iPod/i.test(ua) && !/Version|CriOS/i.test(ua)){
        tipoDispositivoMovil = "iOS"
      }
      else{ // Sobremesa
        tipoDispositivoMovil = "Web"
      }

    }

    return tipoDispositivoMovil
}

exports.abrirFichaApp = function(plataforma){

    if( plataforma.includes("iOS") ){
        window.location.href = "https://apps.apple.com/es/app/helias/id1662492279"
    }
    else if( plataforma.includes("Android") ){
        window.location.href = "https://play.google.com/store/apps/details?id=com.fevergy.helias"
    }    

}

exports.obtenerURLAplicacionDeTerceros = function(nombreAplicacion){

    var tipoDispositivoMovil = module.exports.obtenerTipoPlataforma()
    var enlace = ""
            
    if(nombreAplicacion === "EFERGY"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/efergy-engage/id582931289" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://drive.google.com/file/d/1Zz9LtS6TzJJLZxyVlX2UFqYgqztnG1MV/view" }   
      else{ enlace = "https://engage.efergy.com/user/login" }   
    }
    else if(nombreAplicacion === "EWELINK"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/ewelink-smart-home/id1035163158" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/search?q=ewelink&c=apps&gl=ES" }    
      else{ enlace = "https://ewelink.cc/" }   
    }
    else if(nombreAplicacion === "FUSIONSOLAR"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/fusionsolar/id1529080383" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://intl.fusionsolar.huawei.com/pvmswebsite/nologin/assets/build/index.html#/jumppage" } 
      else{ enlace = "https://eu5.fusionsolar.huawei.com/unisso/login.action?service=%2Funisess%2Fv1%2Fauth%3Fservice%3D%252Fnetecowebext%252Fhome%252Findex.html#/LOGIN" }    
    }    
    else if(nombreAplicacion === "SMARTLIFE"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/smart-life-smart-living/id1115101477" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.tuya.smartlife&hl=es&gl=US" }  
      else{ enlace = "https://ismartlife.me/" }   
    }
    else if(nombreAplicacion === "TUYA"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/tuya-smart/id1034649547" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.tuya.smart&hl=es&gl=US" }  
      else{ enlace = "https://www.tuya.com/" }   
    }
    else if(nombreAplicacion === "TESLA"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/tesla/id582007913" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.teslamotors.tesla&hl=es&gl=US" }  
      else{ enlace = "https://auth.tesla.com/oauth2/v1/authorize?redirect_uri=https%3A%2F%2Fwww.tesla.com%2Fteslaaccount%2Fowner-xp%2Fauth%2Fcallback&response_type=code&client_id=ownership&scope=offline_access+openid+ou_code+email+phone&audience=https%3A%2F%2Fownership.tesla.com%2F&locale=es-ES" }   
    }
    else if(nombreAplicacion === "TPLINK"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/kasa-smart/id1034035493" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.tplink.kasa_android&hl=es&gl=US" }  
      else{ enlace = "https://kasa.tplinkra.com/#/app/auth/login?redirect_uri=%2Fapp%2Fkasacare%3Fredirected%3Dtrue" }   
    }
    else if(nombreAplicacion === "VICTRON"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/vrm/id658834560" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=nl.victronenergy&hl=es&gl=US" }  
      else{ enlace = "https://vrm.victronenergy.com/login" }   
    }
    else if(nombreAplicacion === "SHELLY"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/shelly-cloud/id1147141552" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=allterco.bg.shelly&hl=es&gl=US" }  
      else{ enlace = "https://my.shelly.cloud/?#login" }   
    }
    else if(nombreAplicacion === "TAPO"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/tp-link-tapo/id1472718009" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.tplink.iot&hl=es&gl=US" }  
      else{ enlace = "https://tapo.tplinkcloud.com/tapo_web/#/login/signIn" }   
    }
    else if(nombreAplicacion === "ARISTON"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/ariston-net/id980286873" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.remotethermo.aristonnet&hl=es&gl=US" }        
      else{ enlace = "https://www.ariston-net.remotethermo.com/R2/Account/Login?ReturnUrl=%2FR2%2FHome" }   
    }
    else if(nombreAplicacion === "BRONPI"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/pt/app/bronpi-home/id1530360280" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.micronovasrl.ninabronpi" }  
      else{ enlace = "http://www.bronpiapp.com/v2/index.php" }   
    }
    else if(nombreAplicacion === "SOLARWEB"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/solar-web/id1528302827" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.fronius.solarweb" }  
      else{ enlace = "https://login.fronius.com/authenticationendpoint/login.do?client_id=mf_o9iTAyKemNLQTa6Sp6HYonCIa&commonAuthCallerPath=%2Foauth2%2Fauthorize&forceAuth=false&nonce=638167163927659637.MzZmYThmYzQtNGMwYy00Y2E5LWE4ZGQtNTQwNzVkMDgyYzcwMzczZWM4MTMtMzUzNC00MWU4LTkzM2UtMWY4MGZhNWZhZjlm&passiveAuth=false&redirect_uri=https%3A%2F%2Fwww.solarweb.com%2FAccount%2FExternalLoginCallback&response_mode=form_post&response_type=code+id_token&scope=openid+profile+solarweb+solweb_browserid_a919388382c7d9925b84c2068482b90f&state=OpenIdConnect.AuthenticationProperties%3DvaRWTIjmq98zom72PoiTKor4Y76YFb8vgSUjLph97LWkOKEjRKMGGbAVAhFtcNiIirhTWwDMbcUpyDQgLf_8PF1WMvKSpij5eXbM4H7woC-bNPD7iDcaQIe8AwYyx8BuIMWuoSZLdeGSsE6ao3pr1tavwvxskKFeS5Elq1TpNNvrhs8E2P8043EQAVTSZL37D0F8FkR19xW26bOlzQWi9NOwn9BdPF-jfs6Oj-O4D25HWxr2KRi2mP-QWQ6XfSlgfXG08LilUgyv4xdxXEob0FJfq9g&tenantDomain=carbon.super&x-client-SKU=ID_NET461&x-client-ver=6.9.0.0&sessionDataKey=4260fd8d-096c-46c4-91cc-69410def9169&relyingParty=mf_o9iTAyKemNLQTa6Sp6HYonCIa&type=oidc&sp=Solar.web+-+Portals&isSaaSApp=false&authenticators=SAMLSSOAuthenticator:Fronius%20Login;CustomAuthenticatorLocalMain:LOCAL:LOCAL" }   
    }
    else if(nombreAplicacion === "ECOFORESTCONTROL"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/ecoforest-control/id1543893094" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.mariosilva.ecoforestControl" }  
      else{ enlace = "https://ecoforesthome.com/es/user" }   
    }
    else if(nombreAplicacion === "BROADLINK"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/broadlink/id1450257910" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=cn.com.broadlink.econtrol.international" }  
      else{ enlace = "https://www.broadlink.com.es/login.php" }   
    }
    else if(nombreAplicacion === "HOME_ASSISTANT"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/home-assistant/id1099568401" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=io.homeassistant.companion.android" }  
      else{ enlace = "https://www.home-assistant.io/" }   
    }
    else if(nombreAplicacion === "IAQUALINK"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/iaqualink/id443059509" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.zodiac.iaqualink" }  
      else{ enlace = "https://iaqualink.zodiacpoolsystems.com/signin.html" }   
    }
    else if(nombreAplicacion === "MELCLOUD"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/melcloud/id667989366" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=mitsubishi.wifi.android.mitsubishiwifiapp" }  
      else{ enlace = "https://app.melcloud.com/" }   
    }
    else if(nombreAplicacion === "COMFORT_CLOUD"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/panasonic-comfort-cloud/id1348640525" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.panasonic.ACCsmart" }  
      else{ enlace = "https://www.panasonic.com/global/hvac/air-conditioning/connectivity/comfort-cloud.html" }   
    }
    else if(nombreAplicacion === "MEROSS"){
      if( tipoDispositivoMovil.includes("iOS") ){ enlace = "https://apps.apple.com/es/app/meross/id1260842951" }
      else if( tipoDispositivoMovil.includes("Android") ){ enlace = "https://play.google.com/store/apps/details?id=com.meross.meross" }  
      else{ enlace = "https://www.meross.com/" }   
    }
  
    return enlace
  
}

exports.esAñoBisiesto = function(year){
    return (year % 400 === 0) ? true : 
          (year % 100 === 0) ? false : 
            year % 4 === 0;
};

exports.limpiarDatosSesion = function(){
  
  try{
    localStorage.removeItem("ruleDirectLink"+localStorage.getItem("installationId"))
  } catch(error){}    

  try{
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".accessToken")
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".refreshToken")
    localStorage.removeItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".clockDrift")                
  } catch (error) {        
      console.log('Datos de sesión de usuario no encontrados: ', error);                
  }
  localStorage.removeItem("amplify-signin-with-hostedUI")
  localStorage.removeItem("ongoingStepConfiguration")
  localStorage.removeItem("ongoingInstallationConfiguration")     
  localStorage.removeItem("customizedWorkflow")             
  localStorage.removeItem("deviceToConfigure")
  localStorage.removeItem("installationId")        
  localStorage.removeItem("accountID")        
  localStorage.removeItem("installationName")        
  localStorage.removeItem("installationConfigurationMode")        
  localStorage.removeItem("availableInstallations")       
  localStorage.removeItem("ongoingInstallationName")                        
  localStorage.removeItem("lastDashboardData")
  localStorage.removeItem("lastSmartDevicesStatus") 
  localStorage.removeItem("activeUserInstallationName") 
  localStorage.removeItem("activeUserInstallation")
  localStorage.removeItem("telegramAccount")        
  localStorage.removeItem("telegramInstallationID")  
  localStorage.removeItem("deepLinkID")        
  localStorage.removeItem("currentSharingStatus")                        
  localStorage.removeItem("lastAccess")         
  localStorage.removeItem("deepLinkBack")          
  localStorage.removeItem("forceUpdate")    
  localStorage.removeItem("dashboardInitialLoad")        
  localStorage.removeItem("forceDashboardRefreshOnMenuHomeClick")        
  localStorage.removeItem("updateAccountIDInstallationColdStartHeating")
  localStorage.removeItem("currentInstallationConfiguration")
  localStorage.removeItem("configuredApps")    
  localStorage.removeItem("firstUpdateBasic") 
  localStorage.removeItem("stripeData")    
  localStorage.removeItem("currentInstallations")   
  localStorage.removeItem("lastAdAdvice")       
  localStorage.removeItem("initialCheck")    
  localStorage.removeItem("showInitialHelp")   
  localStorage.removeItem("installerMode")   
  localStorage.removeItem("sharedUsers")
  localStorage.removeItem("devicesAction")  
  
}